export interface SelectOption {
	value: string;
	label: string;
}

export const situationOptions: SelectOption[] = [
	{ value: 'Regular', label: 'Regular' },
	{ value: 'Irregular', label: 'Irregular' },
];
